export interface PaymentAuthorizationBody {
  address: {
    address: string;
    country: string;
    stateCode: string;
    city: string;
    zipCode: string;
  };
  payer: {
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
  };
}

export interface PaymentAuthorizationResp {
  id: string;
  payloadId: string;
  status: string;
  submittedAt: string;
  authorizedAmount: number;
  capturedAmount: number;
  lastFourDigits: string;
  bin: string;
}
